const Joi = require("joi");

const resetPasswordSchema = (data) => {
  console.log(data);
  const schema = Joi.object({
    // password: Joi.string()
    //   .pattern(
    //     new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
    //   )
    //   .required()
    //   .messages({
    //     "string.pattern.base":
    //       "Password should contain letter, numbers and minimum 8 characters.",
    //     "any.required": "Please enter password.",
    //     "string.empty": "Please enter password.",
    //   }),

    // confirmPassword: Joi.string()
    //   .valid(Joi.ref("password"))
    //   .required()
    //   .messages({
    //     "any.only": "Confirm password must match the password.",
    //     "any.required": "Please enter confirm password.",
    //     "string.empty": "Please enter confirm password.",
    //   }),

    password: Joi.string()
      // .pattern(/^[A-Za-z\d~!@#$%^&*()_+{}|:"<>?\[\]\\\-=',./\s]{8,}$/)
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .when(Joi.ref("$isEditPage"), {
        is: false, // if not edit page => required
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "string.pattern.base":
          "Password must be at least 8 characters long and can include letters, numbers, spaces, and special characters.",
        "any.required": "Please enter Password.",
        "string.empty": "Please enter Password.",
      }),

    newPassword: Joi.string()
      // .pattern(/^[A-Za-z\d~!@#$%^&*()_+{}|:"<>?\[\]\\\-=',./\s]{8,}$/)
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .when(Joi.ref("$isEditPage"), {
        is: false, // if not edit page => required
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "string.pattern.base":
          "Password must be at least 8 characters long and can include letters, numbers, spaces, and special characters.",
        "any.required": "Please enter Password.",
        "string.empty": "Please enter Password.",
      }),

    confirmPassword: Joi.string()
      .valid(Joi.ref("password"), Joi.ref("newPassword"))
      .when(Joi.ref("$isEditPage"), {
        is: false,
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "any.only": "Confirm password must match the password.",
        "any.required": "Please enter confirm password.",
        "string.empty": "Please enter confirm password.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = resetPasswordSchema;
